'use client'

import { useGetProjectId } from '@/app/slugs'
import { GetProjectMarketResultsReportParams } from '@/shared/api/end-points/project'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { MarketResultsResponse } from '../../lib'
import services from '../services'

const useGetMarketResultsReport = (partialParams?: GetProjectMarketResultsReportParams) => {
  const projectIdParams = useGetProjectId()
  const params = partialParams || projectIdParams

  const queryKey = [queryKeys((a, m) => a.project.getProjectMarketResultsReport(params) + m.get)]

  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.getMarketResultsReport(params)),
    enabled: !!params.projectId,
    refetchOnWindowFocus: false,
  })

  return {
    ...query,
    queryKey,
  } as UseQueryResult<MarketResultsResponse> & { queryKey: typeof queryKey }
}

export default useGetMarketResultsReport
